import React from 'react';
import styled from "styled-components";
import {ExclamationTriangleIcon} from "@heroicons/react/24/solid";



export const E_404 = styled.div`
  
  font-weight: bold;
  background: #1f2744;
  color: white;
  width: 100%;
  height: 400px;
  text-align: center;
  margin-top: 300px;
`;



function ErrorPage({status}) {
    return (
        <div>
            <div className="error-page-background ">
                <div className={"error-container h-full"}>
                    <>
                        {status == '401' &&
                            <p>로그인 필요</p>
                        }
                        {status == '403' &&
                            <p>접근권한 없음</p>
                        }
                        {status == '404' &&
                            <div className={'flex flex-col justify-center items-center h-full pb-[10rem]'}>
                                <ExclamationTriangleIcon className={"text-red-600 h-[10rem]"}/>
                                <p className={"text-[1.3rem] mb-3"}>페이지를 찾을수 없습니다.</p>
                                <a href={"/"} className={'hover:underline text-[1rem]'}>
                                    메인페이지로 이동
                                </a>
                            </div>
                        }
                        {!status &&
                            <div className={'flex flex-col justify-center items-center h-full pb-[10rem]'}>
                                <ExclamationTriangleIcon className={"text-red-600 h-[10rem]"}/>
                                <p className={"text-[1.3rem] mb-3"}>작업중입니다.</p>
                                <a href={"/"} className={'hover:underline text-[1rem]'}>
                                    메인페이지로 이동
                                </a>
                            </div>
                        }
                    </>
                </div>
            </div>
        </div>
    );
}

export default ErrorPage;
